import { LEXICON_SLIDER_SCALE_SIZE } from './LexiconSlider'
import type { Slide } from './LexiconSliderComponent'

export const ActiveSlide = ({
  slide,
  minHeight,
}: {
  slide: Slide
  minHeight: number | undefined
}) => {
  const activeStyle = !!minHeight
    ? {
        minWidth: `${minHeight + LEXICON_SLIDER_SCALE_SIZE}px`,
        minHeight: `${minHeight + LEXICON_SLIDER_SCALE_SIZE}px`,
        backgroundColor: '#fff',
        border: 'solid 2px #2b2d36',
      }
    : {}
  return (
    <div style={activeStyle} className={'keen-slider__slide'}>
      <div
        aria-hidden
        className="flex flex-col justify-center h-full text-accentroGray-full"
      >
        {slide.slide}

        {slide.title && (
          <div className="h-px-20 mt-px-24 text-px-16 leading-px-24 text-center ">
            {slide.title}
          </div>
        )}
      </div>
    </div>
  )
}
